<template>
  <!-- 异常反馈 -->
  <div class="bannerManage div-layout">
    <div class="bannerManage-main">
      <module-title title="异常反馈">
        <div class="right">
          <el-button type="primary" size="medium" @click="getOutTable">
            导出报表
          </el-button>
        </div>
      </module-title>
      <div class="bannerManage-main-contain">
        <el-form
          ref="subjectSearchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="时段选择：">
            <el-date-picker
              v-model="dateValue"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
          <el-form-item label="设备：" label-width="60px">
            <el-select
              v-model="searchForm.device"
              name="advertisementType"
              size="medium"
              class="edit-form-input"
              @change="getDevice"
            >
              <el-option
                v-for="item in deviceList"
                :key="item.equipmentTypeId"
                :label="item.name"
                :value="item.equipmentTypeId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="应用名称：" prop="appName">
            <el-select
              v-model="searchForm.managementId"
              name="appName"
              size="medium"
              class="edit-form-input"
              @change="getAppName"
            >
              <el-option
                v-for="item in locatypeArr"
                :key="item.managementId"
                :label="item.managementName"
                :value="item.managementId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="类型：" label-width="60px">
            <el-select
              v-model="searchForm.deviceType"
              name="advertisementType"
              size="medium"
              class="edit-form-input"
              @change="getDeviceType"
            >
              <el-option
                v-for="item in deviceTypeList"
                :key="item.type"
                :label="item.name"
                :value="item.type"
              />
            </el-select>
          </el-form-item>
          <el-button type="primary" size="medium" icon="el-icon-search" @click="handleSearchFilter">
            查询
          </el-button>
        </el-form>
        <multiple-box :visible="isSelection" :selection-num="selectionNum">
          <span class="handle-span" @click="handleDdelete('more')">批量删除</span>
        </multiple-box>
        <el-table
          id="table-data"
          v-loading="listLoading"
          :data="applicationList"
          fit
          element-loading-text="Loading"
          class="list-table"
          @selection-change="handleSelectionChange"
        >
          <el-table-column label="反馈时间" prop="createDate" align="center" width="158" />
          <el-table-column label="异常类型" prop="type" align="center" width="155">
            <template slot-scope="scope">
              <span v-show="scope.row.type === 1">已安装</span>
              <span v-show="scope.row.type === 2">未知</span>
            </template>
          </el-table-column>
          <el-table-column label="应用名称" prop="managementName" align="center" width="120" />
          <el-table-column label="设备类型" prop="equipmentTypeId" align="center" width="110">
            <template slot-scope="scope">
              <span v-show="scope.row.equipmentTypeId === 1">一体机</span>
              <span v-show="scope.row.equipmentTypeId === 2">课桌</span>
            </template>
          </el-table-column>
          <el-table-column label="设备ID" prop="equipmentId" align="center" width="255" />
          <el-table-column label="设备定位  " prop="equipmentAddress" align="center" />
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
// import fileSaver from 'file-saver'
// import xlsx from 'xlsx'
// 获取API
import { getAbnormalList, getAppName, outTable } from '@/api/productOperation/wisdom/homeFeedback';
// import { getToken } from '@/utils/auth'

export default {
  name: 'BannerManage',
  data() {
    return {
      dateValue: '',
      // 搜索表单
      searchForm: {
        managementId: '', // 应用ID
        deviceType: '', // 设备类型
        device: '', // 设备
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      listLoading: false, // 表格刷新loading
      multipleSelection: [], // 表格多选,
      advtypeArr: [],
      locatypeArr: [],
      deviceTypeList: [{ name: '所有', type: '' }, { name: '已安装', type: 1 }],
      deviceList: [
        { name: '所有', equipmentTypeId: '' },
        { name: '一体机 ', equipmentTypeId: 1 },
        { name: '课桌 ', equipmentTypeId: 2 }
      ],
      applicationList: [],
      advtype: 'advertising_type',
      locatype: 'app_location_type',
      terminaltype: 'terminal_type',
      selectData: {
        managementId: '', // 应用ID
        type: '', // 设备类型
        equipmentTypeId: '' // 设备
      }
    };
  },
  computed: {
    // 获取上传图片地址
    ...mapGetters(['uploadUrl', 'currentProdeuctId']),
    // 是否多选
    isSelection() {
      return this.multipleSelection.length > 0;
    },
    // 多选数量
    selectionNum() {
      return this.multipleSelection.length;
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取类型列表
    getList() {
      getAbnormalList({ pageNum: 1, pageSize: 10, type: 1 }).then((result) => {
        this.applicationList = result.data.list;
        this.searchForm.total = result.data.total;
      });
      getAppName().then((result) => {
        this.locatypeArr = [{ managementName: '所有', managementId: '' }, ...result.data];
      });
    },
    getAppName(val) {
      this.searchForm.managementId = val;
    },
    getDeviceType(val) {
      this.searchForm.deviceType = val;
    },
    getDevice(val) {
      this.searchForm.device = val;
    },
    getOutTable() { // 导出报表
      outTable(this.selectData).then((res) => {
      }).catch((e) => {
        // console.log(e)
        const blob = new Blob([e.data], {
          type: 'application/vnd.ms-excel'
        });
        const fileName = Date.parse(new Date()) + '.xlsx';
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          // 释放内存
          window.URL.revokeObjectURL(link.href);
        }
      });
    },
    // 获取列表
    getInfo() {
      this.listLoading = true;
      const data = {
        type: this.searchForm.deviceType,
        managementId: this.searchForm.managementId,
        equipmentTypeId: this.searchForm.device,
        beginTime: (this.dateValue && this.dateValue.length > 0) ? this.dateValue[0] : '',
        endTime: (this.dateValue && this.dateValue.length > 0) ? this.dateValue[1] : '',
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      this.selectData.type = data.type;
      this.selectData.managementId = data.managementId;
      this.selectData.equipmentTypeId = data.equipmentTypeId;
      this.selectData.beginTime = (this.dateValue && this.dateValue.length > 0) ? this.dateValue[0] : '';
      this.selectData.endTime = (this.dateValue && this.dateValue.length > 0) ? this.dateValue[1] : '';
      getAbnormalList(data).then((res) => {
        this.applicationList = res.data.list;
        this.searchForm.total = res.data.total;
        this.listLoading = false;
      });
    },
    // 表格选择事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getInfo();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getInfo();
    },
    // 条件查询
    handleSearchFilter(val) {
      this.searchForm.pageNum = 1;
      this.getInfo();
    }
  }
};
</script>
<style lang="scss" scoped>
.bannerManage {
  padding-bottom: 20px;
}
.edit-form-input {
  width: 150px;
}
.handle-form-input {
  width: 80%;
}

.upload-picture {
  text-align: right;
  // float: right;
}

.picture-wrapper {
  width: 80%;
  height: 100px;
  margin-top: 10px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
.query {
  display: flex;
  justify-content: center;
  margin-left: -10px;
}
/deep/.query button {
  margin-left: 20px;
}
</style>
